import { Link } from "react-router-dom";
import "../AnnouncmentManagement/Annoucement.css";
import { Helmet } from "react-helmet-async";
import Footer from "../../../customComponents/Footer";

const LaunchpadHome = () => (
  <>
    <Helmet>
      <title>Token Launch Platform | Launchpad</title>
      <meta name="description" content="Join Launchpad – early-stage projects, exclusive token sales. Be first to new tokens." />
      <meta name="keywords" content="token sale platform, Web3 launchpad, early crypto investment, tokens" />
    </Helmet>

    <div className="launchpad_hero_s">
      <div className="container">
        <div className="row">
          <div className="col-sm-7">
            <div className="cnt_banner">
              <h1>Launchpad</h1>
              <p>Your Easiest Way to Top Tokens — Early or at a Discount</p>

              <ul className="launchpadlist">
                <li><span>Total Raised (USDT)</span>12,450,000.50</li>
                <li><span>Total Participants</span>18,240</li>
                <li><span>Listed Projects</span>24</li>
              </ul>
            </div>
          </div>
          <div className="col-sm-5">
            <div className="hero_img">
              <img src="/images/AnnouncementImg/launchpad_hero_img.png" alt="Launchpad" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <section className="project_coin">
      <div className="container">
        <h2>Projects</h2>

        <div className="filter_tabs">
          <button type="button" className="btn active">Live</button>
          <button type="button" className="btn">Upcoming</button>
          <button type="button" className="btn">Ended</button>
        </div>

        <div className="table-responsive_tow">
          <div className="coin_data_table">
            <div className="project_crypto_bl">
              <div className="project_top">
                <div className="coin_lft">
                  <div className="coin">
                    <img src="/images/bitcoin_icon.png" alt="BTC" />
                  </div>
                  <div className="coin_cnt">
                    <div className="hd d-flex">
                      <h3>BTC</h3>
                      <ul className="subcate">
                        <li className="greendark">
                          <button type="button">LIVE</button>
                        </li>
                      </ul>
                    </div>
                    <span>Bitcoin Launch Pool</span>
                  </div>
                </div>
                <div className="total_time_ri">
                  <ul>
                    <li><span>Total Distribution</span> 500,000 BTC</li>
                    <li><span>End Time</span> 4/30/2026, 11:59:59 PM</li>
                  </ul>
                </div>
              </div>

              <div className="d-flex subscribe_data_info">
                <div className="subscribe_user_bl">
                  <div className="d-flex userinfo_top">
                    <div className="subscribe_user_lft">
                      <img src="/images/tether_icon.png" alt="USDT" />
                      <div className="subscribe_cnt">
                        <h4>USDT</h4>
                        <p>Commit USDT to Subscribe BTC</p>
                      </div>
                    </div>
                    <div className="user_right">
                      <i className="ri-user-line"></i>3,420
                    </div>
                  </div>

                  <ul className="exclusivelist">
                    <li>Token Price <span className="text-yellow">1 BTC = 65,000 USDT</span></li>
                    <li>Total Allocation <span>500,000 BTC</span></li>
                    <li>Total Committed <span>8,200,000 USDT</span></li>
                  </ul>
                  <button type="button" className="viewdel_btn">
                    <Link to="/launchpadCoin_Details/static-btc-pool">View Details</Link>
                  </button>
                </div>
              </div>

              {/* {((item?.status || "").toLowerCase() === "live" || (item?.status || "").toUpperCase() === "LIVE") && (
                                            <ul className="duration_data">
                                                <li className="duration_box">
                                                    <div className="duration_label">Ends In</div>
                                                    <div className="countdown_timer">
                                                        {!durations[item._id] ? (
                                                            <div className="countdown_loading">Loading...</div>
                                                        ) : durations[item._id]?.isEnded ? (
                                                            <div className="countdown_ended">Ended</div>
                                                        ) : (
                                                            <>
                                                                <div className="countdown_item">
                                                                    <span className="countdown_value">{String(durations[item._id]?.days || 0).padStart(2, "0")}</span>
                                                                    <span className="countdown_label">Day</span>
                                                                </div>
                                                                <div className="countdown_separator">:</div>
                                                                <div className="countdown_item">
                                                                    <span className="countdown_value">{String(durations[item._id]?.hours || 0).padStart(2, "0")}</span>
                                                                    <span className="countdown_label">Hr</span>
                                                                </div>
                                                                <div className="countdown_separator">:</div>
                                                                <div className="countdown_item">
                                                                    <span className="countdown_value">{String(durations[item._id]?.minutes || 0).padStart(2, "0")}</span>
                                                                    <span className="countdown_label">Min</span>
                                                                </div>
                                                                <div className="countdown_separator">:</div>
                                                                <div className="countdown_item">
                                                                    <span className="countdown_value">{String(durations[item._id]?.seconds || 0).padStart(2, "0")}</span>
                                                                    <span className="countdown_label">Sec</span>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </li>
                                            </ul>
                                        )}*/}
            </div>

            <div className="project_crypto_bl">
              <div className="project_top">
                <div className="coin_lft">
                  <div className="coin">
                    <img src="/images/eth_currency_img.svg" alt="ETH" />
                  </div>
                  <div className="coin_cnt">
                    <div className="hd d-flex">
                      <h3>ETH</h3>
                      <ul className="subcate">
                        <li className="greendark">
                          <button type="button">LIVE</button>
                        </li>
                      </ul>
                    </div>
                    <span>Ethereum Ecosystem Sale</span>
                  </div>
                </div>
                <div className="total_time_ri">
                  <ul>
                    <li><span>Total Distribution</span> 2,000,000 ETH</li>
                    <li><span>End Time</span> 5/15/2026, 6:00:00 PM</li>
                  </ul>
                </div>
              </div>

              <div className="d-flex subscribe_data_info">
                <div className="subscribe_user_bl">
                  <div className="d-flex userinfo_top">
                    <div className="subscribe_user_lft">
                      <img src="/images/tether_icon.png" alt="USDT" />
                      <div className="subscribe_cnt">
                        <h4>USDT</h4>
                        <p>Commit USDT to Subscribe ETH</p>
                      </div>
                    </div>
                    <div className="user_right">
                      <i className="ri-user-line"></i>5,108
                    </div>
                  </div>

                  <ul className="exclusivelist">
                    <li>Token Price <span className="text-yellow">1 ETH = 3,250 USDT</span></li>
                    <li>Total Allocation <span>2,000,000 ETH</span></li>
                    <li>Total Committed <span>4,125,000 USDT</span></li>
                  </ul>
                  <button type="button" className="viewdel_btn">
                    <Link to="/launchpadCoin_Details/static-eth-sale">View Details</Link>
                  </button>
                </div>
              </div>
            </div>

            <div className="project_crypto_bl">
              <div className="project_top">
                <div className="coin_lft">
                  <div className="coin">
                    <img src="/images/AnnouncementImg/bnb_icon.svg" alt="BNB" />
                  </div>
                  <div className="coin_cnt">
                    <div className="hd d-flex">
                      <h3>BNB</h3>
                      <ul className="subcate">
                        <li className="yellodark">
                          <button type="button">UPCOMING</button>
                        </li>
                      </ul>
                    </div>
                    <span>BNB Community Round</span>
                  </div>
                </div>
                <div className="total_time_ri">
                  <ul>
                    <li><span>Total Distribution</span> 150,000 BNB</li>
                    <li><span>End Time</span> 6/1/2026, 12:00:00 PM</li>
                  </ul>
                </div>
              </div>

              <div className="d-flex subscribe_data_info">
                <div className="subscribe_user_bl">
                  <div className="d-flex userinfo_top">
                    <div className="subscribe_user_lft">
                      <img src="/images/tether_icon.png" alt="USDT" />
                      <div className="subscribe_cnt">
                        <h4>USDT</h4>
                        <p>Commit USDT to Subscribe BNB</p>
                      </div>
                    </div>
                    <div className="user_right">
                      <i className="ri-user-line"></i>0
                    </div>
                  </div>

                  <ul className="exclusivelist">
                    <li>Token Price <span className="text-yellow">1 BNB = 620 USDT</span></li>
                    <li>Total Allocation <span>150,000 BNB</span></li>
                    <li>Total Committed <span>0 USDT</span></li>
                  </ul>
                  <button type="button" className="viewdel_btn">
                    <Link to="/launchpadCoin_Details/static-bnb-round">View Details</Link>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="viewmorebtn">
          <a href="#">View More</a>
        </div>
      </div>
    </section>
    <Footer />
  </>
);

export default LaunchpadHome;
